import './App.css';
import { AllRoutes } from './Components/AllRoutes/AllRoutes';

function App() {
  return (
    <div className="App">
      <AllRoutes />
    </div>
  );
}

export default App;
